import React, { useState, useEffect, Fragment } from 'react';
import { useParams } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import Moment from 'react-moment';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons'


const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    gridList: {
        width: 500,
        height: 450,
    },
}));
export default function Tournament() {

    let { id } = useParams();

    const [tournament, setTournament] = useState([])
    const [team, setTeam] = useState([])
    const [value, setValue] = React.useState(0);
    const [images, setImages] = useState([])
    const theme = useTheme();

    useEffect(() => {

        fetch('https://playattitude.fr/tournaments/' + id, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + localStorage.getItem('web_bm')
            })
        }).then(res => res.json())
            .then(res => {
                console.log('tournois', res)
                setTournament(res[0])

            })
        fetch('https://playattitude.fr/admin/tournaments/inscrit/' + id, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': 'Bearer ' + localStorage.getItem('web_bm')
            })
        }).then(res => res.json())
            .then(res => {
                console.log('toto', res)
                setTeam(res)

            })
            .then(() => {
                let user_id = "test"
                fetch('https://playattitude.fr/img/list/' + user_id)
                .then(res => res.json())
                    .then(res => {
                        setImages(res.map(value => user_id + "_" + value))
                    })
            })
    }, [])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleChangeIndex = index => {
        setValue(index);
    };

    function levelText(level) {
        return level == 3 ? "Confirmé" : level == 2 ? "Intermédiaire" : "Novice"
    }

    function renderTeam() {
        let count = 0
        let result = []
        for (let i in team) {
            count++
            result.push(<Row>
                <Col>
                    <Row>
                        <Col><h3>Equipe n° {count}</h3></Col>
                    </Row>
                        {renderMembers(team[i])}
                </Col>
            </Row>)
        }
        console.log(result)
        return result
    }

    function renderMembers(team) {
        let result = []
        team.forEach(member => {
        result.push(<Row><Col>{member.email}</Col>
        {checkCaptain(member)}
            {checkValidate(member.validated)}
            </Row>)
        })
        return result
    }

    function checkCaptain(member){
        if(!member.captain_id){
            return <Fragment>
            <Col>Capitaine</Col>
            <Col><Moment format="DD/MM/YYYY hh:mm">{member.date}</Moment></Col>
            </Fragment>
        }
        else {
            return <Fragment>
            <Col></Col>
            <Col></Col>
            </Fragment>
        }
    }

    function checkValidate(validate){
        if(validate)
            return <Col><FontAwesomeIcon icon={faCheck} /></Col>
        else
            return <Col><FontAwesomeIcon icon={faTimes} /></Col>
    }

    return (
        <div>
            <AppBar position="static">
                <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" centered>
                    <Tab label="Détail" {...a11yProps(0)} />
                    <Tab label="Inscription" {...a11yProps(1)} />
                    <Tab label="Images" {...a11yProps(2)} />
                    <Tab label="Articles" {...a11yProps(3)} />
                    <Tab label="Résultat" {...a11yProps(4)} />

                </Tabs>
            </AppBar>
            <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={value}
                onChangeIndex={handleChangeIndex}
            >
                <TabPanel value={value} index={0}>
                    <Container>
                        <Row>
                            <Col sm={9}>
                                <Row>
                                    <Col>
                                        <h2>{tournament.name}</h2>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <p><strong>Code Postal :</strong> {tournament.zipcode}</p>
                                    </Col>
                                    <Col>
                                        <p><strong>Ville :</strong> {tournament.city}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <p><strong>Addresse :</strong> {tournament.address}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <p><strong>Debut :</strong><Moment format="DD/MM/YYYY hh:mm">{tournament.start}</Moment></p>
                                    </Col>
                                    <Col>
                                        <p><strong>Fin :</strong><Moment format="DD/MM/YYYY hh:mm">{tournament.end}</Moment></p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <p><strong>Format :</strong> {tournament.format}</p>
                                    </Col>
                                    <Col>
                                        <p><strong>Niveau :</strong> {levelText(tournament.level)}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <p><strong> Frais d'inscription :</strong> {tournament.price} €</p>
                                    </Col>
                                    <Col>
                                        <p><strong>Cashprize: </strong>{tournament.cashprize} €</p>
                                    </Col>
                                </Row>

                            </Col>
                            <Col>
                                <img style={{ width: '100%' }} src={'http://playattitude.fr/img/' + tournament.id + ".png"}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <p> {tournament.description}</p>
                            </Col>
                        </Row>
                    </Container>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Container>
                        {renderTeam()}
                    </Container>
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <Container>
                        <GridList cellHeight={400} className={theme.gridList} cols={6}>
                            {images.map(image => (
                                <GridListTile key={image} cols={2}>
                                    <img src={"http://playattitude.fr/img/" + image} alt={image} />
                                </GridListTile>
                            ))}
                        </GridList>
                    </Container>
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <Container>
                       <p>Articles</p>
                    </Container>
                </TabPanel>
                <TabPanel value={value} index={4}>
                    <Container>
                       <p>Résultats</p>
                    </Container>
                </TabPanel>
            </SwipeableViews>
        </div>
    );
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}